import { usePunchFlow } from '@src/context/PunchFlowContext';
import { PinEntryGrid } from './PinEntryGrid';
import './PunchPad.css';

export function PunchPad() {
    const { state, handlePin } = usePunchFlow();
    return (
        <div className="punch-pad">
            <PinEntryGrid
                onSubmit={handlePin}
                disabled={state.phase !== 'idle'}
                loading={state.phase === 'loading_status'}
            />
        </div>
    );
}
